module.exports = __webpack_public_path__ + "img/dg-navigation-cjdr.dfe522bd.png";